import { cn, ClassValue } from "@/libs/utils/tailwind/cn";

export default function HamburgerIcon({ className }: Props) {
  return (
    <svg
      className={cn(className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 28 24"
    >
      <rect width="28" height="2" rx="1" fill="currentColor" />
      <rect y="11" width="28" height="2" rx="1" fill="currentColor" />
      <rect y="22" width="28" height="2" rx="1" fill="currentColor" />
    </svg>
  );
}

interface Props {
  className?: ClassValue;
}
